import React, { type MouseEvent, type ReactNode, type Ref } from 'react';
import cx from 'classnames';
import styled from '@emotion/styled';
import i18n from 'i18next';
import { rememberFilterTrigger } from './filterPopupFocus';

const t = i18n.getFixedT(null, 'common');

const DROPDOWN_OPEN_CLASS = 'ant-dropdown-open';

const TriggerButton = styled.button`
  border: 0;
  background: transparent;
  font-family: inherit;
`;

type FilterTriggerProps = {
  icon: ReactNode;
  columnTitle: ReactNode;
  columnKey: string;
  popupRole?: 'dialog' | 'menu';
  active?: boolean;
  className?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  ref?: Ref<HTMLButtonElement>;
};

export const FilterTrigger = ({
  icon,
  columnTitle,
  columnKey,
  popupRole,
  active,
  className,
  onClick,
  ...rest
}: FilterTriggerProps) => (
  <TriggerButton
    {...rest}
    type="button"
    data-testid={`filter-trigger-${columnKey}`}
    className={cx('ant-table-filter-trigger', { active }, className)}
    aria-label={
      popupRole === 'menu'
        ? t('Filter by {{placeholder}}', { placeholder: columnTitle })
        : t('Search {{placeholder}}', { placeholder: columnTitle })
    }
    aria-haspopup={popupRole}
    aria-expanded={!!className?.includes(DROPDOWN_OPEN_CLASS)}
    onClick={(event) => {
      rememberFilterTrigger(event.currentTarget);
      onClick?.(event);
      event.stopPropagation();
    }}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') event.stopPropagation();
    }}
  >
    {icon}
  </TriggerButton>
);

export default FilterTrigger;
